 import {openLink} from './link'
 import to_casher from './casher'
 import buyVIP from '../../api/order'
 import openMiniProgram from './miniProgram'

 export default function (info, success_cb = null, cancel_cb = null) {

  const action_info = info.action_info;
  // let source = window.gact.source;
  switch (info.action_type) {
    case 'link':
      setTimeout(() => {
        let link_url = action_info.url;
        if(!link_url){
          return
        }

        if(/\$\{.*\}/.test(link_url)){
          link_url = link_url.eval({gact,$bus,params});
        }
        openLink(link_url);
      }, 100);
      break;
    //收银台
    case "cashier":
      to_casher();
      break;
    case 'openVip':
        buyVIP(action_info.product_id, '', '', action_info.pay_channel);
      break;
    case 'miniProgram':
      openMiniProgram(action_info.appId, action_info.orginId, action_info.path);
      break;
    default:
      break;
  }

}
